import { Model3d } from "./Model3d";
import { Env } from "./Env";
import { JPG } from "./JPG";

export class Data{
    static async get(objectData) {
        const formData = new FormData();
        for (const key in objectData) {
            formData.append(key, objectData[key]);
        }
        if (Env.corps_cabinets_cart_data) {
            try {
                const cart_cabinet = await fetch(Env.corps_cabinets_cart_data, {
                    method: 'POST'
                });
                const json = await cart_cabinet.json();
                for (const key in Env.cabinets_cart_data) {
                    delete Env.cabinets_cart_data[key];
                }
                for (const key in json) {
                    Env.cabinets_cart_data[key] = json[key];
                }
            } catch (e) {
                console.debug(e);
            }
        } else {
            const formUpdate = new Promise(async function(resolve, reject) {
                try {
                    const corps_type = objectData['corps_type'];
                    const result = await fetch(`${Env.url_corps_show_form}/${corps_type}`, {
                        method: 'POST',
                        body: formData
                    });
                    const html = await result.text();
                    postMessage({ formHTMLReplace: html });
                    resolve(html);
                } catch (e) {
                    console.debug(e);
                    reject();
                }
            });
            const panels_position_update = new Promise(async function(resolve, reject) {
                try {
                    const result = await fetch(Env.corps_panel_position, {
                        method: 'POST',
                        body: formData
                    });
                    const json = await result.json();
                    for (const key in json) {
                        delete Env.panels_position[key];
                        Env.panels_position[key] = json[key];
                    }
                    for (const i in Env.panels_position['3d_model']) {
                        Env.panels_position['3d_model'][i].url = Env.panels_position['3d_model'][i].url.replace('../../../', '');
                    }
                    await JPG.setImageBitmaps();
                    await Model3d.setModels();
                    Env.draw.worldReady = true;
                    postMessage({ panelsPosition: json });
                    resolve(json);
                } catch (e) {
                    console.debug(e);
                    reject();
                }
            });
            await Promise.all([formUpdate, panels_position_update]);
        }
    }
}